/**
 * @generated SignedSource<<97d6e76437b4dbd55ebe950f05a5fbe4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "updateServiceDescription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homeMerchantActionsServiceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homeMerchantActionsServiceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c251876c9ab2ed7a88c34f50a1bd7915",
    "id": null,
    "metadata": {},
    "name": "homeMerchantActionsServiceMutation",
    "operationKind": "mutation",
    "text": "mutation homeMerchantActionsServiceMutation(\n  $request: UpdateServiceDescriptionRequestInput\n) {\n  updateServiceDescription(request: $request) {\n    id\n    description\n    version\n  }\n}\n"
  }
};
})();

node.hash = "c9fe1a03c3c4aa8092388b565d5aaa66";

module.exports = node;
